import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation updateStoreMutation($input: UpdateStoreInput!) {
    updateStore(input: $input) {
      store {
        ...BrandEdit_brand
      }
      errors {
        key
        messages
      }
    }
  }
`;

const updateStore = (environment, attributes, args = {}) => {
  const {
    backgroundImage,
    logoImage,
    locationMap,
    ...otherAttributes
  } = attributes;

  const uploadables = {};

  if (backgroundImage) {
    uploadables.brandBackgroundImage = backgroundImage;
  }

  if (logoImage) {
    uploadables.brandLogoImage = logoImage;
  }

  if (locationMap) {
    uploadables.brandLocationMap = locationMap;
  }

  return commit(environment, {
    mutation,
    uploadables,
    variables: {
      input: otherAttributes,
    },
    ...args,
  });
};

export default updateStore;
